import { applyMiddleware } from '@reduxjs/toolkit';

export const bindMiddleware = (middleware = []) => {
    if (process.env.NODE_ENV !== 'production') {
        /* eslint-disable import/no-extraneous-dependencies, @typescript-eslint/no-var-requires, global-require */
        const { composeWithDevTools } = require('redux-devtools-extension');
        return composeWithDevTools({ trace: true, traceLimit: 25 })(applyMiddleware(...middleware));
    }

    return applyMiddleware(...middleware);
};
